import {
  TRANSACTION_REQUEST_ACTION_FAILURE,
  TRANSACTION_REQUEST_ACTION_REQUEST,
  TRANSACTION_REQUEST_ACTION_RESET,
  TRANSACTION_REQUEST_ACTION_SUCCESS,
} from "./paymentActions";

const INITIAL_STATE = {
  loading: false,
  success: false,
  error: false,
};

const transactionRequestReducer = (state = INITIAL_STATE, action) => {
  const { type } = action;
  switch (type) {
    case TRANSACTION_REQUEST_ACTION_RESET: {
      return INITIAL_STATE;
    }
    case TRANSACTION_REQUEST_ACTION_REQUEST: {
      return {
        loading: true,
        success: false,
        error: false,
      };
    }
    case TRANSACTION_REQUEST_ACTION_SUCCESS: {
      return {
        loading: false,
        success: true,
        error: false,
      };
    }
    case TRANSACTION_REQUEST_ACTION_FAILURE: {
      return {
        loading: false,
        success: false,
        error: true,
      };
    }
    default:
      return state;
  }
};

export default transactionRequestReducer;
